import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'

@Component
export default class FormValidationMixin extends Vue  {

  @Prop({default: ''})
  public rules: string | Array<any>

  @Prop()
  public vid: string

  get validates() {
    return this.rules && this.rules.length > 0
  }
}
